import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Navbar } from 'reactstrap';
import { FadeLoader } from 'react-spinners';
import ReactGA from 'react-ga';
import Img from 'react-image';

import YoutubeView from '../components/YoutubeView';
import { getVideosTesti } from '../actions/VideosActions';
import noimage from '../assets/images/noimage.jpg';

class Testimonials extends React.Component {

	state = {
		toggle: false,
		yid: ''
	}

	componentWillMount() {
		ReactGA.pageview('/Testimoneales');
		this.props.getVideosTesti();
	}

	_goBack() {
		this.props.history.goBack();
	}

	_toggle() {
		this.setState({ toggle: !this.state.toggle });
	}

	_openVideo(yid) {
		this.setState({ yid });
		this._toggle();
		// ReactGA.pageview('/Testimoneales/https://youtu.be/' + yid);
	}

	_videoAsistida(yid) {
		ReactGA.pageview('/Testimoneales/asistida/https://youtu.be/' + yid);
	}

	_renderItems(items) {
		if (items.length > 0) {
			return items.map((obj, i) => (
				<div className="photoContainer large" key={i} onClick={() => this._openVideo(obj.yid)}>
					<Img
						src={[obj.img, noimage]}
						loader={<FadeLoader color={'#462177'} loading={true} />}
					/>
				</div>
			));
		}
		else return [];
	}

	render() {
		const videos = this._renderItems(this.props.videosTesti);

		return (
			<div className="sp-page">
				<Navbar className="sp-nav">
					{/* <div className="sp-bk ico-sp-cvleft" onClick={() => this._goBack()}></div> */}
					<div className="sp-label">Videos de Testimonials</div>
					<div>&nbsp;</div>
				</Navbar>
				<div className="sp-content img">
					<div className="fred">
						{videos}
					</div>
				</div>

				<YoutubeView
					yid={this.state.yid}
					isOpen={this.state.toggle}
					toggle={() => this._toggle()}
					onPlay={e => this._videoAsistida(this.state.yid)}
				/>
			</div>
		);
	}
}

const mapStateToProps = state => ({ videosTesti: state.VideosReducer.videosTesti });

export default withRouter(connect(mapStateToProps, { getVideosTesti })(Testimonials));


// WEBPACK FOOTER //
// ./src/screens/Testimonials.js